export enum InternetQuality {
  GOOD = 'good',
  NORMAL = 'normal',
  BAD = 'bad',
}

const MIN_SIZE_OCTETS_FOR_CALC = 1000;
const MIN_DOWNLOAD_TIME_MS_FOR_CALC = 10;
const OUR_DOMAIN = location.protocol + '//' + location.hostname;

let cachedInternetQuality: number = 0;

/**
 * Определяем скорость интернета (в мбит/с) пользователя на основе уже загруженных ресурсов
 * @return {number|null}
 */
const getInternetSpeedFromResource = (): number => {
  /**
   * Выбираем самый тяжёлый ресурс из последних 5-и. На его основе будем производить расчёты
   * @type {PerformanceEntry}
   */
  const bigResource = (performance
    .getEntriesByType('resource') as PerformanceResourceTiming[])
    .filter((resource) => {
      return resource.transferSize > MIN_SIZE_OCTETS_FOR_CALC
        && (Math.floor(resource.responseEnd) - Math.floor(resource.responseStart)) > MIN_DOWNLOAD_TIME_MS_FOR_CALC
        && resource.name.startsWith(OUR_DOMAIN)
    })
    .slice(-5)
    .sort((a, b) => {
      return a.transferSize - b.transferSize;
    })
    .pop();

  // Если ресурсы не были загружены, то берём закешированное значение
  if (!bigResource) {
    return cachedInternetQuality;
  }

  // Время скачивания ресурса в секундах
  const downloadDuration = (bigResource.responseEnd - bigResource.responseStart) / 1000;
  // Размер скачанных данных в мбит
  const transferSizeMbit = bigResource.transferSize * 0.000008;

  // вычисляем мбит/с
  let result = Number((transferSizeMbit / downloadDuration).toFixed(2));

  // Очищаем ресурсы, чтобы всегда получать актуальную скорость интернета
  performance.clearResourceTimings();
  cachedInternetQuality = result;

  return result;
}

/**
 * Получаем качество интернет-соединения пользователя
 * @return {string}
 */
export const getInternetQuality = (): string => {
  const speedMbps = navigator?.connection?.downlink || getInternetSpeedFromResource();

  if (speedMbps > 5) {
    return InternetQuality.GOOD;
  }
  if (speedMbps > 0.35) {
    return InternetQuality.NORMAL;
  }
  return InternetQuality.BAD;
}
